import EditAvatar from '@/components/EditAvatar'
import { updateUser } from '@/services/user/user.service'
import { fetchUser, selectUser } from '@/store/user/user.slice'
import { useRequest } from 'ahooks'
import { Button, Card, Col, Form, Input, Row } from 'antd'
import classnames from 'classnames'
import React, { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './index.module.less'
import { AppDispatch } from '@/store'
import { cancelMySubscription, getCurrentPlan } from '@/services/subscription/subscription.service'

export default memo(function SettingProfile() {
  const [form] = Form.useForm()
  const dispatch = useDispatch<AppDispatch>()
  const userInfo = useSelector(selectUser).userInfo!
  const {data, run: getMyPlan} = useRequest(getCurrentPlan)
  const {subscription} = data || {}
  const { run } = useRequest(updateUser, {
    manual: true,
    onSuccess: () => {
      dispatch(fetchUser())
    }
  })

  const removeSubscription = async () => {
    await cancelMySubscription()
    getMyPlan()
  }

  useEffect(() => {
    form.setFieldsValue(userInfo)
  }, [userInfo])

  return (
    <div className={classnames('border p-2', styles.container)}>
      <Row gutter={16} className={'py-2'}>
        <Col span={14}>
          <Form
            form={form}
            autoComplete='off'
            layout='vertical'
            onFinish={(values) => {
              run({ id: userInfo.id, ...values })
            }}
          >
            <Form.Item
              label='Full Name'
              name='fullName'
              rules={[{ required: true, message: 'Please enter full name' }]}
            >
              <Input placeholder='Enter your full name' />
            </Form.Item>

            <Form.Item>
              <Button htmlType='submit' type='primary'>
                Save
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={10}>
          <EditAvatar
            value={userInfo?.avatar}
            metaData= {{userId: userInfo.id}}
            avatarSize={160}
            name={userInfo?.fullName}
            onChange={(avatar) => run({ avatar, id: userInfo.id })}
          />
        </Col>
      </Row>
      {subscription?.plan && <Row>
        <Card title="Subscription" style={{width: '100%'}}>
          <div>Plan: {subscription?.plan}</div>
          <div>Subscription: {subscription?.status}</div>
          {subscription?.status === 'active' && subscription.billingStatus !== 'cancel' && <div className='mt-1'>
            <Button danger onClick={removeSubscription}>Stop Subscription</Button>
          </div>}
        </Card>
      </Row>}
    </div>
  )
})
